import { ANGULAR_TOKEN_OPTIONS, AngularTokenOptions } from '@raysuelzer/angular-token';

import { environment } from 'environments/environment';

/**
 * Options used to pass to the Angular2Token
 * init method.
 */

export function angularTokenOptionsFactory(): AngularTokenOptions {
  return {
    // IMPORTANT:  When apiBase is '' as is the case when deployed,
    // AngularToken will add the request headers to CORS requests
    // this breaks cors and leaks keys.
    // Use a factory here to make sure that the api base is current url
    // The environment file now defines apiBase as a getter which returns
    // window.location.orgin in production mode.
    apiBase: environment.apiBase,
    apiPath: 'api',
    signInPath: 'auth/sign_in',
    resetPasswordCallback: 'reset_password',
    signOutFailedValidate: false,
    updatePasswordPath: 'auth/password',
    signInRedirect: 'login',
  };
}

export const authOptions: AngularTokenOptions  = {
  angularTokenOptionsProvider: { provide: ANGULAR_TOKEN_OPTIONS, useFactory: angularTokenOptionsFactory }
};
